module.exports = __webpack_public_path__ + "static/media/posten.41c82a3c.png";